var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "updates-tab" },
    [
      _vm.updates.length === 0 && !_vm.isAddFormOpened && _vm.updatesLoaded
        ? [
            _c(
              "div",
              { staticClass: "empty-timeline-message" },
              [
                _vm.isMy
                  ? [
                      _c("div", { staticClass: "text_large" }, [
                        _vm._v(_vm._s(_vm.i18n.sale_tab_updates_ismy_header()))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "text_small text_margin text_description"
                        },
                        [_vm._v(_vm._s(_vm.i18n.sale_tab_updates_ismy_text()))]
                      ),
                      _vm._v(" "),
                      _vm.isMy
                        ? _c(
                            "md-button",
                            {
                              staticClass: "btn md-primary",
                              on: { click: _vm.openForm }
                            },
                            [_vm._v(_vm._s(_vm.i18n.sale_add_note_bt()))]
                          )
                        : _vm._e()
                    ]
                  : _c("div", { staticClass: "text_large" }, [
                      _vm._v(_vm._s(_vm.i18n.sale_upd_tab_important_updated()))
                    ])
              ],
              2
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isAddFormOpened && _vm.updatesLoaded
        ? _c("add-update-form", {
            staticClass: "updates-tab__add-form",
            attrs: { sale: _vm.sale },
            on: {
              close: _vm.closeForm,
              "timeline-add-finished": _vm.getUpdates
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAddFormOpened && _vm.updates.length > 0 && _vm.updatesLoaded
        ? _c("timeline", {
            staticClass: "updates-tab__timeline",
            attrs: { items: _vm.updates, sale: _vm.sale },
            on: { "timeline-add-click": _vm.openForm }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53a1b18c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53a1b18c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/tabs/Sales.UpdatesTab.vue
// module id = tK+4
// module chunks = 1